module.exports = ['$rootScope', '$http', function ($root, $http) {
    "use strict";

    return {
        get: function (order_request_id, plant_id) {
            var url = `/plant/${plant_id}/order_request/${order_request_id}/`;
            return $http.get(url, {});
        },
        approve: function (order_request, plant_id) {
            var url = `/plant/${plant_id}/order_request/${order_request.id}/approve/`;
            return $http({
                method: 'PATCH',
                url: url,
                data: order_request
            });
        },
        reject: function (order_request, plant_id, reason) {
            var url = `/plant/${plant_id}/order_request/${order_request.id}/reject/`;
            return $http({
                method: 'PATCH',
                url: url,
                data: {
                    order_request: order_request,
                    reason: reason
                }
            });
        },
        create: function (order_request, plant_id) {
            var url = `/plant/${plant_id}/order_request/new/`;
            return $http({
                method: 'POST',
                url: url,
                data: order_request
            });
        },
        update: function (order_request, plant_id) {
            var url = `/plant/${plant_id}/order_request/${order_request.id}/`;
            return $http({
                method: 'PATCH',
                url: url,
                data: order_request
            });
        },
        list: function (plant_id) {
            var url = `/plant/${plant_id}/order_request/list/`;
            return $http({
                method: 'GET',
                url: url
            });
        },
        new_requests_count: function (plant_id) {
            var url = `/plant/${plant_id}/new_requests_count/`;
            return $http({
                method: 'GET',
                url: url,
            });
        }
    };
}];
